import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { Loading } from "go-core/components/Loading";
import { ClientDetailsImportContext } from "../services/types";

interface Props {
	show: boolean;
	onHide: () => void;
	clientId: string;
	requests: ClientDetailsImportContext;
}

const ClientSecretModal = ({ show, onHide, clientId, requests }: Props) => {
	const { t } = useTranslation();
	const [clientSecret, setClientSecret] = useState<string>("");
	const { addFlash } = useFlash();

	useEffect(() => {
		fetchClientSecret();
	}, []);

	const fetchClientSecret = async () => {
		try {
			const res = await requests.getClientSecret(clientId);
			setClientSecret(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>{t("lib:go_component.client_details.field.client_secret.title")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>{clientSecret ? <p className="mb-0">{clientSecret}</p> : <Loading />}</Modal.Body>
		</Modal>
	);
};

export default ClientSecretModal;
